import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { CompanyMasterService } from "../../Services/company-master.service";
import { CompanyMaster } from "../../Model/company-master";
import { NgxSmartModalService } from "ngx-smart-modal";
import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder
} from "@angular/forms";
import { CompanyMasterValidators } from "./company-master-validators";
import { ToastrService } from "ngx-toastr";
import { ComponentSecurityService } from "src/app/Main/Services/component-security.service";
import Swal from "sweetalert2";

@Component({
  selector: "app-company-master-revisions",
  templateUrl: "./company-master-revisions.component.html",
  styleUrls: ["./company-master-revisions.component.css"]
})
export class CompanyMasterRevisionsComponent implements OnInit {
  public companyMaster: CompanyMaster[];
  public columnDefs = [];
  public rowData = [];
  private gridApi;
  private gridColumnApi;
  private gridOptions;
  private defaultColDef;
  private rowSelection;
  private crudAction;
  public form: FormGroup;
  public canUpdateForm: boolean;
  public clicked: boolean = false;

  constructor(
    private service: CompanyMasterService,
    public ngxSmartModalService: NgxSmartModalService,
    private companyMasterValidators: CompanyMasterValidators,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private securityService: ComponentSecurityService
  ) {
    this.defaultColDef = { sortable: true, filter: true };
    this.rowSelection = "single";
    this.createFormGroup();
    this.createGridColumnDefs();
  }

  @ViewChild("name", { static: true }) nameField: ElementRef;

  ngOnInit() {
    this.service.getAll().subscribe(
      response => {
        if (response.length > 0) {
          this.rowData = response;
        } else {
          this.rowData = null;
          this.toastr.warning("No records found", "Warning");
        }
      },
      error => {
        this.toastr.error("Unable to access database", "Error");
      }
    );

    // Get form security
    this.securityService
      .canUpdate(this.constructor.name, localStorage.getItem("user"))
      .subscribe(
        response => {
          if (response.length > 0) this.canUpdateForm = true;
          else {
            this.canUpdateForm = false;
          }
        },
        error => {
          this.canUpdateForm = false;
        }
      );
  }

  createFormGroup() {
    this.form = this.fb.group(
      {
        name: new FormControl(null, [Validators.required]),
        nbrPeriods: new FormControl(""),
        yearStartDate: new FormControl(""),
        apYearStartDate: new FormControl(""),
        arYearStartDate: new FormControl(""),
        currPeriod: new FormControl(""),
        apCurrPeriod: new FormControl(""),
        arCurrPeriod: new FormControl(""),
        prd1EndDate: new FormControl(""),
        prd2EndDate: new FormControl(""),
        prd3EndDate: new FormControl(""),
        prd4EndDate: new FormControl(""),
        prd5EndDate: new FormControl(""),
        prd6EndDate: new FormControl(""),
        prd7EndDate: new FormControl(""),
        prd8EndDate: new FormControl(""),
        prd9EndDate: new FormControl(""),
        prd10EndDate: new FormControl(""),
        prd11EndDate: new FormControl(""),
        prd12EndDate: new FormControl(""),
        prd13EndDate: new FormControl(""),
        changeID: new FormControl(""),
        lastUpdated: new FormControl(""),
        id: new FormControl("")
      },
      {
        validator: this.companyMasterValidators.shouldBeUnique.bind(this)
      }
    );
  }

  createGridColumnDefs() {
    this.columnDefs = [
      { headerName: "id", field: "id", hide: true },
      { headerName: "changeID", field: "changeID", hide: true },
      { headerName: "lastUpdated", field: "lastUpdated", hide: true },
      {
        headerName: "Company Name",
        field: "name",
        filter: "agTextColumnFilter"
      },
      {
        headerName: "Number of Periods",
        field: "nbrPeriods",
        filter: "agTextColumnFilter"
      },
      {
        headerName: "Year Start Date",
        field: "yearStartDate",
        filter: "agTextColumnFilter"
      },
      {
        headerName: "AP Year Start Date",
        field: "apYearStartDate",
        filter: "agTextColumnFilter"
      },
      {
        headerName: "AR Year Start Date",
        field: "arYearStartDate",
        filter: "agTextColumnFilter"
      },
      { headerName: "currPeriod", field: "currPeriod", hide: true },
      { headerName: "apCurrPeriod", field: "apCurrPeriod", hide: true },
      { headerName: "arCurrPeriod", field: "arCurrPeriod", hide: true },
      { headerName: "Period 1 End Date", field: "prd1EndDate", hide: true },
      { headerName: "Period 2 End Date", field: "prd2EndDate", hide: true },
      { headerName: "Period 3 End Date", field: "prd3EndDate", hide: true },
      { headerName: "Period 4 End Date", field: "prd4EndDate", hide: true },
      { headerName: "Period 5 End Date", field: "prd5EndDate", hide: true },
      { headerName: "Period 6 End Date", field: "prd6EndDate", hide: true },
      { headerName: "Period 7 End Date", field: "prd7EndDate", hide: true },
      { headerName: "Period 8 End Date", field: "prd8EndDate", hide: true },
      { headerName: "Period 9 End Date", field: "prd9EndDate", hide: true },
      { headerName: "Period 10 End Date", field: "prd10EndDate", hide: true },
      { headerName: "Period 11 End Date", field: "prd11EndDate", hide: true },
      { headerName: "Period 12 End Date", field: "prd12EndDate", hide: true },
      { headerName: "Period 13 End Date", field: "prd13EndDate", hide: true }
    ];
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
    setTimeout(() => this.nameField.nativeElement.focus());
  }

  onSelectionChanged(event) {
    // only open the window of row selected
    if (event.node.selected) {
      this.ngxSmartModalService.setModalData(
        this.gridApi.getSelectedRows()[0],
        "myModal",
        true
      );
      this.crudAction = "Update";
      this.loadInitialFormValues();
      this.ngxSmartModalService.getModal("myModal").open();
      setTimeout(() => this.nameField.nativeElement.focus());
    }

    // capture the event, so deselectall can be call when window closed
    this.gridOptions = event;
  }

  export() {
    let params = {
      fileName: "CompanyMaster",
      allColumns: true
    };
    this.gridApi.exportDataAsExcel(params);
  }

  loadInitialFormValues() {
    this.form.patchValue({
      name: this.gridApi.getSelectedRows()[0]["name"],
      nbrPeriods: this.gridApi.getSelectedRows()[0]["nbrPeriods"],
      yearStartDate: this.gridApi.getSelectedRows()[0]["yearStartDate"],
      apYearStartDate: this.gridApi.getSelectedRows()[0]["apYearStartDate"],
      arYearStartDate: this.gridApi.getSelectedRows()[0]["arYearStartDate"],
      currPeriod: this.gridApi.getSelectedRows()[0]["currPeriod"],
      apCurrPeriod: this.gridApi.getSelectedRows()[0]["apCurrPeriod"],
      arCurrPeriod: this.gridApi.getSelectedRows()[0]["arCurrPeriod"],
      prd1EndDate: this.gridApi.getSelectedRows()[0]["prd1EndDate"],
      prd2EndDate: this.gridApi.getSelectedRows()[0]["prd2EndDate"],
      prd3EndDate: this.gridApi.getSelectedRows()[0]["prd3EndDate"],
      prd4EndDate: this.gridApi.getSelectedRows()[0]["prd4EndDate"],
      prd5EndDate: this.gridApi.getSelectedRows()[0]["prd5EndDate"],
      prd6EndDate: this.gridApi.getSelectedRows()[0]["prd6EndDate"],
      prd7EndDate: this.gridApi.getSelectedRows()[0]["prd7EndDate"],
      prd8EndDate: this.gridApi.getSelectedRows()[0]["prd8EndDate"],
      prd9EndDate: this.gridApi.getSelectedRows()[0]["prd9EndDate"],
      prd10EndDate: this.gridApi.getSelectedRows()[0]["prd10EndDate"],
      prd11EndDate: this.gridApi.getSelectedRows()[0]["prd11EndDate"],
      prd12EndDate: this.gridApi.getSelectedRows()[0]["prd12EndDate"],
      prd13EndDate: this.gridApi.getSelectedRows()[0]["prd13EndDate"],
      changeID: this.gridApi.getSelectedRows()[0]["changeID"],
      lastUpdated: this.gridApi.getSelectedRows()[0]["lastUpdated"],
      id: this.gridApi.getSelectedRows()[0]["id"]
    });
    this.clicked = false;
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.form.controls;
  }

  modalAction() {
    switch (this.crudAction) {
      case "Update":
        this.service
          .update(
            this.form.value,
            this.ngxSmartModalService.getModalData("myModal").id
          )
          .subscribe(
            response => {
              if (response["success"] == "true")
                this.toastr.success("Record updated", "Success");
              this.service.getAll().subscribe(data => {
                this.rowData = data;
                this.gridApi.setRowData(this.rowData);
              });
            },
            error => {
              this.toastr.error("Record not updated", "Error");
            }
          );
        this.ngxSmartModalService.get("myModal").close();

        break;
      case "Create":
        this.service.create(this.form.value).subscribe(
          response => {
            if (response["success"] == "true")
              this.toastr.success("New record added", "Success");
            this.service.getAll().subscribe(data => {
              this.rowData = data;
              this.gridApi.setRowData(this.rowData);
            });
          },
          error => {
            this.toastr.error("Record not added", "Error");
          }
        );
        this.ngxSmartModalService.get("myModal").close();

        break;
      case "Delete":
        this.service
          .delete(this.ngxSmartModalService.getModalData("myModal").id)
          .subscribe(
            response => {
              this.toastr.success("Record deleted", "Success");
              this.service.getAll().subscribe(data => {
                this.rowData = data;
                this.gridApi.setRowData(this.rowData);
              });
            },
            error => {
              this.toastr.error("Record not deleted", "Error");
            }
          );
        this.ngxSmartModalService.get("myModal").close();

        break;
    }
  }

  close() {
    if (typeof this.gridOptions != "undefined")
      this.gridOptions.api.deselectAll();
  }

  create() {
    this.crudAction = "Create";
    this.ngxSmartModalService.resetModalData("myModal");
    this.form.reset();
    this.clicked=false;
    this.ngxSmartModalService.getModal("myModal").open();
    setTimeout(() => this.nameField.nativeElement.focus());
  }

  // delete() {
    // this.crudAction = "Delete";
    // if (window.confirm("Are sure you want to delete this item ?")) {
      // this.modalAction();
    // } else {
      // this.ngxSmartModalService.get("myModal").close();
    // }
  // }

  delete() {
    this.crudAction = "Delete";
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!"
    }).then(result => {
      if (result.value) {
        this.modalAction();
      }
    });
  }
}
